import React from "react";
import { mdiCogOutline, mdiBellOutline, mdiShieldCheckOutline } from "@mdi/js";
import HowItWorksModal from "app/components/common/HowItWorksModal";
import "./clientBookingSettings.css";

const ROWS = [
  {
    icon: mdiCogOutline,
    title: "Configure Your Schedule",
    body: (
      <p>
        Morph uses the settings to calculate your availability. Clients will
        only see time slots that fit the specific rules and tiers you define.
      </p>
    ),
  },
  {
    icon: mdiBellOutline,
    title: "Share & Automate",
    body: (
      <>
        <p>
          Once turned on, share your link to accept bookings 24/7. When a
          request comes in, Morph automatically:
        </p>
        <ul>
          <li>Blocks the time on your Job Calendar</li>
          <li>Notifies you immediately</li>
        </ul>
      </>
    ),
  },
  {
    icon: mdiShieldCheckOutline,
    title: "Verify & Finalize",
    body: (
      <>
        <p>You remain in full control. We recommend you:</p>
        <ul>
          <li>
            Review details: Check the property detail and time, and call the
            client to confirm access
          </li>
          <li>
            Edit if needed: You can update the duration or reschedule the job
            directly in your calendar
          </li>
        </ul>
      </>
    ),
  },
];

const HowClientBookingWorksModal = ({ show, onHide }) => (
  <HowItWorksModal
    show={show}
    onHide={onHide}
    title="How Client Booking Works"
    rows={ROWS}
    className="how-booking-works-modal-wrapper"
  />
);

export default HowClientBookingWorksModal;
